/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Filters_LabelInputs */

const en_us2_exercise_filters_label = /** @type {(inputs: Exercise_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const pt_br2_exercise_filters_label = /** @type {(inputs: Exercise_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const es_419_exercise_filters_label = /** @type {(inputs: Exercise_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const pt_pt2_exercise_filters_label = /** @type {(inputs: Exercise_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const fr_fr2_exercise_filters_label = /** @type {(inputs: Exercise_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres`)
};

const de_de2_exercise_filters_label = /** @type {(inputs: Exercise_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const it_it2_exercise_filters_label = /** @type {(inputs: Exercise_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Exercise_Filters_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_filters_label = /** @type {((inputs?: Exercise_Filters_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Filters_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_filters_label(inputs)
	if (locale === "es-419") return es_419_exercise_filters_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_filters_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_filters_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_filters_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_filters_label(inputs)
	return en_us2_exercise_filters_label(inputs)
});
export { exercise_filters_label as "exercise.filters_label" }